<template>
  <FormContainer class="login-form" @submitForm="login">
    <FormErrors v-if="error">
      <Alert status="danger" class="m-0">
        <template v-if="error === 'login'">
          Email o password non corrette, riprovare.
        </template>
        <template v-else>
          Errore di sistema, riprovare più tardi.
        </template>
      </Alert>
    </FormErrors>

    <div class="row">
      <FormInputTextWidget
        class="col-12"
        label="Email"
        placeholder="example@email.com"
        v-model="user.email"
        :errorMsg="errorHash.email"
        type="email"
        @input="removeError('email')"
      />
      <FormInputTextWidget
        class="col-12"
        label="Password"
        v-model="user.password"
        :errorMsg="errorHash.password"
        type="password"
        @input="removeError('password')"
      />
      <div class="col-12">
        <div class="row mt-2">
          <div class="col-12 text-right mb-3">
            <router-link :to="{ name: 'password-reset', params: { email: user.email || null } }">
              Password Dimenticata?
            </router-link>
          </div>
          <div class="col-12 col-md">
            <button class="btn btn-primary px-5" type="submit">Accedi</button>
          </div>
        </div>
      </div>
    </div>
  </FormContainer>
</template>

<script>
import md5 from 'md5';
import validateMixin from '../../../libs/Form/mixins/validate';

export default {
  name: 'login',
  data () {
    return {
      error: null,
      user: {
        email: null,
        password: null,
      },
    };
  },
  components: {
    FormInputTextWidget: () => import('../../../libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormContainer: () => import('../../../libs/Form/components/FormContainer'),
    FormErrors: () => import('../../../libs/Form/components/FormErrors'),
    Alert: () => import('../../../libs/Feedback/components/Alert'),
  },
  mixins: [validateMixin],
  methods: {
    login () {
      this.error = null;

      if (!this.isValid()) {
        return;
      }

      this.$oauth2
        .loginWithCredentials(this.user.email, this.user.password)
        .then(me => {
          const email = this.$localStorage.get('signup-email', null);
          const token = this.$localStorage.get('signup-token', null);

          if (email && md5(me.email) === email && token) {
            return this.$router.push({
              name: 'profile-signup',
              params: {
                email,
                token,
              },
            });
          }

          return this.$router.push({ name: 'root' });
        })
        .catch(error => {
          if (error?.response?.status === 401) {
            this.error = 'login';
          } else if (error) {
            this.error = 'service';
          }
        })
      ;
    },
    isValid () {
      if (!this.user.email) {
        this.addError('Inserire l\'email.', 'email');
      } else if (!this.validateEmail(this.user.email)) {
        this.addError('Email non valida.', 'email');
      }

      if (!this.user.password) {
        this.addError('Inserire la password.', 'password');
      }

      return !this.hasErrors;
    },
    validateEmail (email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },
};

</script>

<style lang="scss"></style>
